import axios from 'axios';
import { Utils } from '../common';

class Axios {
  constructor() {
    const newBaseUrl = Utils.getUrlAddress(window.location.href).replace(/\/+$/g, '');
    this.baseUrl = `${newBaseUrl}/`;
    axios.defaults.baseURL = this.baseUrl;
    axios.defaults.headers.post['Content-Type'] = 'application/json';

    const axiosConfig = {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    };

    const instance = axios.create(axiosConfig);

    // You can alter axios defaults after instance has been created from the client
    // const api = new AxiosInstance();
    // api.defaults.headers.common['Authorization'] = AUTH_TOKEN;
    return instance;
  }
}

const api = new Axios();

module.exports = { api };
